import React, { useState } from 'react'
import { Box, Button, Typography, CircularProgress } from '@material-ui/core'

import { snackbar } from 'components'
import { useApiCall } from 'hooks'

import { updateAllPasses } from '../api'
import { useStyles } from './styles'

interface UpdatePassesResponse {
  success: boolean
  message: string
  googleWalletClasses: number
  appleWalletPasses: number
}

export const ECard: React.FC = () => {
  const classes = useStyles()
  const [updateResult, setUpdateResult] = useState<UpdatePassesResponse | null>(null)

  const [updatePassesApi, isUpdatePassesLoading] = useApiCall<
    Record<string, never>,
    UpdatePassesResponse
  >(updateAllPasses)

  const handleUpdatePasses = async () => {
    try {
      // Clear previous result when starting new process
      setUpdateResult(null)

      const result = await updatePassesApi({})
      setUpdateResult(result)
      snackbar.show('Proceso ejecutado exitosamente')
    } catch (error) {
      console.error('Error updating passes:', error)
      snackbar.show('Error al actualizar las tarjetas. Intente de nuevo.')
    }
  }

  return (
    <Box className={classes.container}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Actualización de Tarjetas Digitales
      </Typography>

      <Box className={classes.info}>
        <Typography variant="body2">
          Este proceso actualizará todas las tarjetas de Google Wallet y Apple Wallet con el nuevo
          logo y diseño. Las tarjetas se actualizarán automáticamente en los dispositivos de los
          usuarios.
        </Typography>
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={handleUpdatePasses}
        disabled={isUpdatePassesLoading}
        className={classes.button}
        startIcon={isUpdatePassesLoading ? <CircularProgress size={20} /> : null}
      >
        {isUpdatePassesLoading ? 'Actualizando...' : 'Actualizar Tarjetas'}
      </Button>

      {updateResult && (
        <Box className={classes.success}>
          <Typography variant="body2">{updateResult.message}</Typography>
        </Box>
      )}
    </Box>
  )
}
